export function generateDisplayName(firstName?: string, lastName?: string): string {
  const displayName = `${firstName || ''} ${lastName || ''}`.trim()
  return displayName.length > 0 ? displayName : ''
}